import { InitPage } from "../index";

class CRMInfo {
  constructor() {
    $("document").ready(function () {
      $(".crm-info").on("click", function (e) {
        e.preventDefault();
        $("#crm-info-body").html("");
        const body = JSON.parse(e.currentTarget.dataset.body);
        Object.keys(body).forEach((key) => {
          const span = $(document.createElement("div"));
          span.html(
            `<b class="text-capitalize">${key.replace("_", " ")}:</b> ${body[key]}`,
          );
          $("#crm-info-body").append(span);
        });
        $("#crm-info").modal("show");
      });
    });
  }
}

export function LoadPage() {
  InitPage("orders", () => new CRMInfo());
  InitPage("schedules", () => new CRMInfo());
  InitPage("invoices", () => new CRMInfo());
}
